export const companyData = [
  {
    companyName: "Magic Bit",
    altText: "Magic Bit Logo and tagline Innovation Made Easy",
    background:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/pitch-deck/magic-bit/backbround-magic-bit-pitch-01.png",
    companyLogo:
      "https://media.licdn.com/dms/image/C510BAQGdffX7_5TAhQ/company-logo_200_200/0/1569659903356?e=1702512000&v=beta&t=UMo3TPekEgiE5CaJfSZewsWQta0ZHGnPMdEsIsctG6M",
    description:
      "Magicbit provides STEM kits for kids to create 100+ innovative projects in coding, robotics, IoT & electronics with project based learning.",
    tags: ["edTech", "Customers"],
    targetInvestment: "US500,000",
    comingSoon: false,
    onPitchDeck: true,
    url: "/in/dev-magic-bit",
  },
  {
    companyName: "boostNET",
    altText: "an EV car connected to a charging station",
    background:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/boostnet-background-01.jpg",
    companyLogo:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/boostNET-logo.png",
    description:
      "A mobile app will allow EV users to find charging points and top up their accounts, ensuring efficient utilization. Boostnet aims to provide affordable solutions and a comprehensive dashboard for station owners and management.",
    tags: ["Energy", "Ideation", "Mentors", "Investor"],
    targetInvestment: "US30,000",
    comingSoon: true,
    onPitchDeck: false,
    url: "http://boostnet.lk",
  },
  {
    companyName: "Trash For Trade",
    altText: "fishermen on boat collecting plastic waste from a river",
    background:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/trash-for-trade-backrgound.jpg",
    companyLogo:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/trash-for-trade-logo.png",
    description:
      "Trash for Trade is a Plastic Upcycling Social Enterprise.It is a social innovation idea developed from an open-source community, ‘Precious Plastic’ with the support of DreamSpace Academy. We have taken upon this initiative using the upcycling machinery our team has built.",
    tags: ["cleanTech", "Social"],
    onPitchDeck: false,
    comingSoon: false,
    targetInvestment: "undisclosed",
    url: "https://trashfortrade.com/",
  },
  {
    companyName: "Designer Dent",
    altText: "model of teeth with fillings",
    background:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/designer-dent-background.jpg",
    companyLogo:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/designer-dent-logo.png",
    description:
      "DesignerDent is using latest technologies and trends in CAD/CAM industry to introduce and apply innovative solutions primarily in Oral Care/ Dentistry for global markets.",
    tags: ["medTech"],
    onPitchDeck: false,
    comingSoon: false,
    targetInvestment: "undisclosed",
    url: "https://designerdent.com/",
  },
  {
    companyName: "Meeedly",
    altText: "screen shot of the application on a laptop",
    background:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/meeedly-background.jpg",
    companyLogo:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/meeedly-logo.png",
    description:
      "A productivity and analytics tool designed to make online meetings with virtual teams more engaging!",
    tags: ["edTech"],
    onPitchDeck: false,
    comingSoon: false,
    targetInvestment: "USD200,000",
    url: "https://meeedly.com/",
  },
  {
    companyName: "MCQ MED",
    altText: "screenshot of application",
    background:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/mcq-background.jpg",
    companyLogo:
      "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-pitch-deck/companyData/mcq-logo.png",
    description:
      "MCQ Med is a bootstrapped EdTech company focused on transforming medical education. Our question bank of MCQs helps medical students excel in their final licensing exams, which account for 75% of their final grade.",
    tags: ["medTech"],
    onPitchDeck: false,
    comingSoon: false,
    targetInvestment: "USD75,000",
    url: "https://mcqmed.lk/",
  },
  //   {
  //     companyName: "",
  //     altText: "",
  //     background: "",
  //     companyLogo: "",
  //     description: "",
  //     tags: ["", ""],
  //     onPitchDeck: false,
  //     comingSoon: false,
  //     targetInvestment: "",
  //     url: "",
  //   },
];
